import { TJsonQuery } from '../../../packages/JsonQuery';
import { IAppState } from '../../common/state';

export function selectJsonQuery(state: IAppState): TJsonQuery {
  return state.results.jsonQuery;
}
